export const getEstimates = (state) => state.estimates
export const getEstimatesMeta = (state) => state.meta_data
export const getEstimateStatus = (state) => state.status